import React, { useEffect } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelectCheckmarks({ type, multiList, setTypeFingerVals, setkeybFeaturesWhy}) {
  const [values, setValues] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setValues(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  useEffect(() => {
    if (type === 'typingHabitFingers') {
    setTypeFingerVals(values)
    } else if (type === 'keyboardFeaturesWhy') {
      setkeybFeaturesWhy(values)
    }
  }, [values])

  return (
    <div>
      <FormControl sx={{ m: 1, width: '100%', margin: 0 }}>
        {/* <InputLabel id="demo-multiple-checkbox-label">Tag</InputLabel> */}
        <Select
          //   labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={values}
          onChange={handleChange}
          input={<OutlinedInput
          // label="Tag" 
          />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {multiList.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={values.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
